import { render } from "./BlckSignaturePopup.vue?vue&type=template&id=b38c1828&scoped=true"
import script from "./BlckSignaturePopup.vue?vue&type=script&lang=js"
export * from "./BlckSignaturePopup.vue?vue&type=script&lang=js"

import "./BlckSignaturePopup.vue?vue&type=style&index=0&id=b38c1828&scoped=true&lang=css"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b38c1828"]])

export default __exports__